// eslint-disable-next-line import/prefer-default-export
export const IMAGE_ORIGINAL_URL = 'imageOriginalUrl';
